module.exports = "/_next/static/images/improve-cash-flow-cdb252c0798bf828abc2da2635e06032.svg";